import React, { useCallback } from 'react'
import { Redirect, RouteProps, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { ApplicationState } from 'rootReducer'
import { makeLoadingSelector } from 'common/Loading/reducer'
import LoadingPage from 'pages/LoadingPage'
import SaveRedirect from 'common/Routes/SaveRedirect'

interface UnverifiedPrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>
  authenticated: boolean
  emailVerified: boolean
  isLoading?: boolean
  allowVerified: boolean
}

export const UnverifiedPrivateRouteComponent = ({
  authenticated,
  emailVerified,
  component: Component,
  isLoading,
  allowVerified,
  ...rest
}: UnverifiedPrivateRouteProps) => {
  const renderComponent = useCallback((): React.ReactNode => {
    if (isLoading) {
      return <LoadingPage />
    }
    if (!authenticated) {
      return <SaveRedirect to="/login/" />
    }
    if (authenticated && emailVerified && !allowVerified) {
      return <Redirect to="/" />
    }
    return <Component />
  }, [isLoading, authenticated, emailVerified, Component])

  return <Route {...rest} render={renderComponent} />
}

UnverifiedPrivateRouteComponent.defaultProps = {
  isLoading: false,
  allowVerified: false,
}

export const mapStateToProps = (state: ApplicationState) => ({
  authenticated: state.user.authenticated,
  emailVerified: state.user.user !== null && state.user.user.email_verified,
  isLoading: !state.user.fetched || makeLoadingSelector(['USER_AUTHENTICATED'])(state),
})

export default connect(mapStateToProps)(UnverifiedPrivateRouteComponent)
